package game

import com.soywiz.kds.FastArrayList
import com.soywiz.kds.iterators.fastForEach
import com.soywiz.korio.dynamic.mapper.ObjectMapper
import com.soywiz.korio.dynamic.serialization.parseTyped
import com.soywiz.korio.file.std.resourcesVfs
import com.soywiz.korio.serialization.json.Json
import com.soywiz.korui.layout.MathEx.max

class JsonSprite(
    val id: String,
    val width: Int = 1,
    val height: Int = 1,
    val colOffset: Int = 0,
    val rowOffset: Int = 0,
    val room: String,
    val useBgColor: Boolean,
    val frames: List<CharSpriteFrame>,
)

class JsonSpriteList(val sprites: List<JsonSprite>)

suspend fun loadSprites(rooms: List<Room>): List<CharSprite> {

    val mapper = ObjectMapper()
    mapper.registerType {
        CharSpriteFrame(
            it["duration"].gen(Int::class),
            it["col"].gen(Int::class),
            it["row"].gen(Int::class),
        )
    }
    mapper.registerType {
        val width = max(1, it["width"].gen(Int::class))
        val height = max(1, it["height"].gen(Int::class))
        JsonSprite(
            it["id"].gen(String::class),
            width,
            height,
            it["colOffset"].gen(Int::class),
            it["rowOffset"].gen(Int::class),
            it["room"].gen(String::class),
            it["useBgColor"].gen(Boolean::class),
            it["frames"].genList(CharSpriteFrame::class),
        )
    }
    mapper.registerType {
        JsonSpriteList(
            it["sprites"].genList(JsonSprite::class)
        )
    }

    val json = resourcesVfs["sprites.json"].readString()

    val jsonSpriteList = Json.parseTyped<JsonSpriteList>(json, mapper)

    val spriteList = FastArrayList<CharSprite>()

    jsonSpriteList.sprites.fastForEach {
        val room = rooms.filter { room -> room.id == it.room }[0]

        val sprite = CharSprite(
            it.id,
            it.width,
            it.height,
            it.colOffset,
            it.rowOffset,
            room,
            it.frames,
            it.useBgColor
        )

        spriteList.add(sprite)
    }

    return spriteList
}